<template>
  <wizard-base
    class="rooms"
    :title="$t('WIZARD.ROOMS.TITLE')"
    :subtitle="$t('GENERAL.FIELD_REQUIRED')"
  >
    <div class="rooms__fields">
      <HdTileSelect
        v-model="numberOfRooms"
        :items="roomItems"
        :formatter="$formatNumber"
        accept-new-value
        type="number"
        name="rooms-value"
        class="rooms__select"
      />
      <PriceContributionInput v-model="roomsPrice" name="rooms" class="rooms__input" />
    </div>
    <template v-if="shouldShowQuestionnaire" #secondary-section>
      <div class="rooms__question">
        <h3 class="rooms__question__title">
          {{ $t('WIZARD.GENERAL_QUESTIONS.QUESTIONS.FLOOR_PLAN') }}
        </h3>
        <TileSelectWithReset
          v-model="floorPlan"
          :items="yesNoOptions"
          name="hasfloorPlan"
          type="string"
          class="rooms__question__options"
        />
      </div>
      <div class="rooms__question">
        <h3 class="rooms__question__title">
          {{ $t('WIZARD.GENERAL_QUESTIONS.QUESTIONS.LIVING_SPACE_CALCULATION') }}
        </h3>
        <TileSelectWithReset
          v-model="livingSpaceCalculation"
          :items="yesNoOptions"
          name="hasLivingSpaceCalculation"
          type="string"
          class="rooms__question__options"
        />
      </div>
    </template>
  </wizard-base>
</template>

<script>
// Components
import { HdTileSelect } from 'homeday-blocks';
import WizardBase from '@/layout/WizardBase.vue';
import PriceContributionInput from '@/components/PriceContributionInput.vue';
import TileSelectWithReset from '@/components/TileSelectWithReset.vue';
// Services
import { mapFeatures } from '@/services/feature';
import { mapPriceContributions } from '@/services/priceContribution';
// Constants
import CONFIG from '@/config/env';

export default {
  name: 'RoomsSlide',
  components: {
    WizardBase,
    HdTileSelect,
    PriceContributionInput,
    TileSelectWithReset,
  },
  data() {
    return {
      roomItems: [1, 1.5, 2, 2.5, 3, 3.5, 4],
    };
  },
  computed: {
    deal() {
      return this.$store.state.wizard.currentDeal;
    },
    ...mapFeatures(['numberOfRooms', 'floorPlan', 'livingSpaceCalculation']),
    ...mapPriceContributions(['rooms']),
    yesNoOptions() {
      return [
        {
          text: this.$t('WIZARD.GENERAL_QUESTIONS.OPTION.YES'),
          value: true,
        },
        {
          text: this.$t('WIZARD.GENERAL_QUESTIONS.OPTION.NO'),
          value: false,
        },
        {
          text: this.$t('WIZARD.GENERAL_QUESTIONS.OPTION.DONT_KNOW'),
          value: 'dont_know', // will be converted to null before sending the evaluation
        },
      ];
    },
    shouldShowQuestionnaire() {
      return CONFIG.feature_flags.edm_questionnaire;
    },
  },
  created() {
    // If we don't have the initially selected value as an option, we add it if it's valid
    if (this.numberOfRooms) {
      const initalItem = this.roomItems.find((value) => value === this.numberOfRooms);

      if (!initalItem && this.numberOfRooms) {
        this.roomItems.push(this.numberOfRooms);
      }
    }

    // For a better UX we sort the items
    this.roomItems.sort((a, b) => a - b);
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';
.rooms {
  &__fields {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__select {
    width: 100%;
    @include font('DS-100');
  }

  &__input {
    max-width: 200px;
    margin-top: $sp-l;
  }

  &__question {
    margin: 0 auto $sp-m;
    text-align: center;
    max-width: 30rem;
    h3 {
      margin-bottom: $sp-m;
    }
  }
}
</style>
